import React, { useContext, useEffect, useState } from 'react'
import AdlMenu from './AdlMenu';
import BeginAppraisalTab from './BeginAppraisalTab';
import AppraisalInfoMain from './AppraisalInfoMain';
import SendPlainTextEmail from './SendPlainTextEmail';
import TaskModal from '../Modals/TaskModal';
import TextMessageTab from './TextMessageTab';
import FollowUpDateForms from './FollowUpDateForms';
import LeadTaskItem from '../Leads/LeadTaskItem';
import ModalLayout from '../Modals/ModalLayout';
import TaskDetailsModal from '../Leads/TaskDetailsModal';
import { LeadsContext } from '../Context/LeadsContext';
import ScriptModal from '../Modals/ScriptModal';


const AppraisalDetails = ({ close, appraisalData, appraisalStage }) => {
// console.log("appraisal Details Data", appraisalData)
    const { updateTask, updateLeadDataMultiple, activeLeadAction, getLeadData } = useContext(LeadsContext);
    const [editingAppraisal, setEditingAppraisal] = useState(false)
    const handleAdMenu = () => {
        setEditingAppraisal(true)
    }
    // Task Details
    const [taskStates, setTaskStates] = useState(appraisalData?.tasks);

    useEffect(() => {
        console.log("task data changed", appraisalData, appraisalData?.tasks);
        if (appraisalData?.tasks) {
            setTaskStates(appraisalData.tasks);
        }
    }, [appraisalData, appraisalData?.tasks]);
    
    const handleRadioChange = (index, value) => {
        console.log("radio change", index, value, taskStates[index]);
        const newTaskStates = [...taskStates];
        newTaskStates[index]['completed'] = value;
        setTaskStates(newTaskStates);

        // console.log(appraisalData.tasks[index]);

        updateTask(appraisalData.id, appraisalData.tasks[index].id, appraisalData.tasks[index].text, value);
    };
    const [openTaskDetails, setOpenTaskDetails] = useState(false);
    const [openEditTaskDetails, setOpenEditTaskDetails] = useState("");
    const handleTaskDetails = (taskEditDtl) => {
        console.log("taskEditDtl", taskEditDtl);
        setOpenTaskDetails(true);
        setOpenEditTaskDetails(taskEditDtl);
        document.body.classList.add('overflow-body');
    }
    const closeTaskDetails = () => {
        setOpenTaskDetails(false);
        document.body.classList.remove('overflow-body');
    }
    const [activeTab, setActiveTab] = useState("AppraisalMain");
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    useEffect(() => {
        console.log("useEffect activeLeadAction",activeLeadAction);
        if(activeLeadAction == "email") setActiveTab("AppraisalSendEmail");
        if(activeLeadAction == "text") setActiveTab("AppraisalSendText");
    },[activeLeadAction]);
    // 
    const [showEtitleBox, setShowEtitleBox] = useState("");

    const [appraisalDetails,setAppraisalDetails] = useState({});

    const checkLeadData = async () => {
        if(appraisalData?.lead_id.includes('SM_') || appraisalData?.partial_lead_data) {
            const data = await getLeadData(appraisalData.id);
            console.log(data);
            data.is_snipermonkey = appraisalData?.lead_id.includes('SM_');
            setAppraisalDetails({...appraisalData,...data});
        } else {
            setAppraisalDetails(appraisalData);
        }
    }

    useEffect(() => {
        if(appraisalData?.lead_id) checkLeadData();     
        else setAppraisalDetails({});

        //setEditingAppraisal(false);
    },[appraisalData]);
    // Script Modal
    
      const [addScriptModal, setScriptModal] = useState(false);
      const [scriptType,setScriptType] = useState("email");
      const onAddScriptBtnClick = (type) => {
            setScriptModal(true);
            setScriptType(type);
      }
      const scriptModalClose = () => {
            setScriptModal(false);
      }

    return (appraisalData && Object.keys(appraisalData) != 0 && 
        <>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title text-center w-100" id="staticBackdropLabel">
                        Appraisal Details
                    </h1>
                    <button className="sm-box-close" type="button" onClick={() => {setEditingAppraisal(); close(); }}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div className="modal-body white-bg px-3" style={{overflow:'hidden'}}>
                    <div className='ad-flex d-flex'>
                        <div className='ad-left mb-lg-0 mb-4'>
                            <AdlMenu close={close} 
                                editingAppraisal={editingAppraisal} 
                                handleAdMenu={handleAdMenu} 
                                paramId={appraisalDetails?.id} 
                                appraisalData={appraisalDetails}
                                showEtitleBox={showEtitleBox}
                            />
                        </div>
                        <div className='ad-right'>
                            <div className="tab-content" id="nav-tabContent">
                                {/* {console.log("editingAppraisal", editingAppraisal)} */}
                                {editingAppraisal ?
                                    <div className="tab-pane fade show active">
                                        <div className='mb-3'><span className='adr-label1 pe-3'>Location</span> <span className='adr-label2 text-uppercase'>{appraisalDetails?.location}</span></div>
                                        <BeginAppraisalTab
                                            appraisalData={appraisalDetails}
                                            setShowEtitleBox={setShowEtitleBox}
                                            setEditingAppraisal={setEditingAppraisal}
                                            close={close}
                                            appraisalStage={appraisalStage}
                                        />
                                    </div> :
                                    <div className="tab-pane fade show active">
                                        <div className='mb-3'><span className='adr-label1 pe-3'>Location</span> <span className='adr-label2 text-uppercase'>{appraisalDetails?.location}</span></div>
                                        {(appraisalStage == "Callback" || appraisalStage == "Completed") && !appraisalDetails.is_snipermonkey ? 
                                        <>
                                            <div className='appraisal-tabs position-relative'>
                                                {(activeTab === "AppraisalSendEmail" || activeTab === "AppraisalSendText") &&  
                                                    <button
                                                        onClick={() => {
                                                            onAddScriptBtnClick(activeTab === "AppraisalSendEmail" ? "email" : "text");
                                                        }}
                                                        className="text-nowrap blue-transparent-btn dark-transparent-btn text-uppercase at-script-btn"
                                                        type="button"
                                                    >
                                                        <span className="blue-add-icon"></span> Add script
                                                    </button>
                                                }
                                                <ul className="nav nav-tabs pt-4 pt-lg-0" id="myTab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${activeTab == "AppraisalMain" ? "active" : ""}`} onClick={() => handleTabClick("AppraisalMain")} type="button" >Main</button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${activeTab == "AppraisalSendEmail" ? "active" : ""}`} onClick={() => handleTabClick("AppraisalSendEmail")} type="button" >Send Email</button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className={`nav-link ${activeTab == "AppraisalSendText" ? "active" : ""}`} onClick={() => handleTabClick("AppraisalSendText")} type="button" >Send Text</button>
                                                    </li>
                                                </ul>
                                                <div className="tab-content" id="myTabContent">
                                                    {activeTab == "AppraisalMain" && 
                                                        <AppraisalInfoMain
                                                            appraisalData={appraisalDetails}
                                                        />                                                    
                                                    }
                                                    {activeTab == "AppraisalSendEmail" && 
                                                        <SendPlainTextEmail
                                                            leadData={appraisalDetails}
                                                            close={close} 
                                                            handleTabClick={handleTabClick} />                                                   
                                                    }
                                                    {activeTab == "AppraisalSendText" && 
                                                        <TextMessageTab
                                                            leadData={appraisalDetails}
                                                            close={close} 
                                                            handleTabClick={handleTabClick} />                                                   
                                                    }
                                                </div>
                                            </div>
                                            {activeTab === "AppraisalMain" ?
                                                <div className='row mt-5'>
                                                    <div className='col-md-7'>
                                                        <div className='md-title text-uppercase avenirNext fw-600 mb-2'>Tasks</div>
                                                        <div className='white-box pt-2 pb-4 px-3 mnh-315'>
                                                            <div className='task-table'>
                                                                <table className='w-100'>
                                                                    <tbody>
                                                                        <tr style={{ borderStyle: 'hidden' }}>
                                                                            {/* <td className=''></td> */}
                                                                            <td colSpan={2} className='task-call-count text-end pt-0'>Completed?</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <div className='ttb-scroll pe-3'>
                                                                    <table className='w-100'>
                                                                        <tbody>
                                                                            <>
                                                                                {taskStates?.map((task, index) =>
                                                                                    <LeadTaskItem
                                                                                        key={index}
                                                                                        index={index}
                                                                                        taskData={task}
                                                                                        handleRadioChange={handleRadioChange}
                                                                                        lead_id={appraisalDetails.id}
                                                                                        handleTaskDetails={handleTaskDetails}
                                                                                    />
                                                                                )}
                                                                            </>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className='mt-3 text-center'>
                                                                <button type='button' className='blue-transparent-btn dark-transparent-btn text-uppercase' onClick={() => handleTaskDetails({ id: taskStates[taskStates.length - 1]?.id + 1, 'lead_id': appraisalDetails.id })}><span className='blue-add-icon me-3'></span> Add Task</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {appraisalDetails?.appraisal_stage != "Callback" && appraisalDetails?.appraisal_stage != "Completed" && <div className='col-md-5'>
                                                        <div className='md-title text-uppercase avenirNext fw-600 mb-2'>FOLLOW UP DATE</div>
                                                        <FollowUpDateForms
                                                            appraisalData={appraisalDetails}
                                                            closeModal={close}
                                                        />
                                                    </div>}
                                                </div>
                                                :
                                                <div className='mt-lg-0 mt-4'>
                                                    <div className='md-title text-uppercase mb-2'>Tasks</div>
                                                    <div className='task-table task-table-box pe-3'>
                                                        <table className='w-100'>
                                                            <tbody>
                                                                <tr style={{ borderStyle: 'hidden' }}>
                                                                    <td colSpan={2} className='task-call-count text-end font-12'>Completed? &nbsp;&nbsp;</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <div className='ttb-scroll pe-3'>
                                                            <table className='w-100'>
                                                                <tbody>
                                                                    {taskStates?.map((task, index) =>
                                                                        <LeadTaskItem
                                                                            key={index}
                                                                            index={index}
                                                                            taskData={task}
                                                                            handleRadioChange={handleRadioChange}
                                                                            lead_id={appraisalDetails.id}
                                                                            handleTaskDetails={handleTaskDetails}
                                                                        />
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </> 
                                        : 
                                        <AppraisalInfoMain
                                            appraisalData={appraisalDetails}
                                        />}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalLayout open={openTaskDetails} waitingCls="true" modalWidth="780px" cls="blue-header-modal" close={closeTaskDetails}>
                <TaskDetailsModal
                    close={closeTaskDetails}
                    openEditTaskDetails={openEditTaskDetails}
                    updateTask={updateTask}
                    updateLeadDataMultiple={updateLeadDataMultiple}
                    noUpdateStage={true}
                />
            </ModalLayout>
            
            <ModalLayout open={addScriptModal} waitingCls="true" modalWidth="980px" cls="blue-header-modal" close={scriptModalClose} >
                <ScriptModal
                    close={scriptModalClose} 
                    scriptType={scriptType} 
                    scriptFilter={"store"}
                />
            </ModalLayout>
        </>
    )
}

export default AppraisalDetails